import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    code: {
      label: {
        id: 'properties.code',
        defaultMessage: 'Code',
        description: 'label of the code field',
      },
    },
    remaining: {
      label: {
        id: 'properties.remaining',
        defaultMessage: 'Remaining',
        description: 'label of the remaining field',
      },
    },
    expiresAt: {
      label: {
        id: 'properties.expiresAt',
        defaultMessage: 'Expires at',
        description: 'label of the expires at field',
      },
    },
    isUnlimited: {
      label: {
        id: 'properties.isUnlimited',
        defaultMessage: 'Unlimited',
        description: 'label of the is unlimited field',
      },
    },
  },
  feedback: {
    copied: {
      id: 'actions.copied',
      defaultMessage: 'Copied to clipboard',
      description: 'feedback after copying to clipboard',
    },
  },
};

export default defineMessages(translations);
